import { testimonials } from '../../../mocks/projects';

const StarRating = ({ rating = 5 }: { rating?: number }) => (
  <div className="flex items-center gap-0.5 mb-4">
    {Array.from({ length: 5 }).map((_, i) => (
      <i
        key={i}
        className={`ri-star-fill text-base ${i < rating ? 'text-amber-400' : 'text-gray-200'}`}
      />
    ))}
  </div>
);

const TestimonialsSection = () => {
  return (
    <section
      className="bg-gray-50 py-24"
      itemScope
      itemType="https://schema.org/LocalBusiness"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <span className="inline-block px-4 py-2 bg-white rounded-full text-xs font-medium text-gray-600 uppercase tracking-wider mb-6">
            Klant Reviews
          </span>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
            WAT ONZE<br />
            KLANTEN ZEGGEN
          </h2>
          <div className="flex items-center gap-3 mt-6">
            <div className="flex items-center gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-400 text-lg" />
              ))}
            </div>
            <span className="text-gray-700 font-semibold text-sm">
              5.0 gemiddelde beoordeling
            </span>
            <span className="text-gray-400 text-sm">
              · {testimonials.length} beoordelingen
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300"
              itemScope
              itemType="https://schema.org/Review"
            >
              {/* Schema.org hidden meta */}
              <meta itemProp="reviewRating" content="5" />
              <meta itemProp="datePublished" content="2024-01-01" />
              <div itemScope itemType="https://schema.org/Rating" itemProp="reviewRating">
                <meta itemProp="ratingValue" content="5" />
                <meta itemProp="bestRating" content="5" />
                <meta itemProp="worstRating" content="1" />
              </div>
              <div itemScope itemType="https://schema.org/LocalBusiness" itemProp="itemReviewed">
                <meta itemProp="name" content="NGP Renovatieproject" />
              </div>

              <StarRating rating={5} />

              <p
                className="text-base text-gray-700 leading-relaxed mb-6"
                itemProp="reviewBody"
              >
                "{testimonial.review}"
              </p>

              <div
                className="flex items-center gap-4"
                itemScope
                itemType="https://schema.org/Person"
                itemProp="author"
              >
                <div
                  className="w-12 h-12 rounded-full flex items-center justify-center text-gray-900 font-bold text-sm shrink-0"
                  style={{ backgroundColor: testimonial.color }}
                >
                  {testimonial.avatar}
                </div>
                <div>
                  <h4
                    className="text-base font-bold text-gray-900"
                    itemProp="name"
                  >
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-500 flex items-center gap-1">
                    <i className="ri-home-4-line"></i>
                    {testimonial.project}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
